/**
 * 법령 기반 요율 store (Zustand)
 *
 * - Firestore (`config/rates/{year}/current`) 의 단일 진실을 메모리에 보관.
 * - 초기값은 default fallback (`ratesDefault2026`). 부트스트랩 시 cache → Firestore 순으로 갱신.
 * - 컴포넌트는 `src/hooks/useRates.ts` 의 selector hook 으로 구독 (직접 store 사용 지양).
 */

import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { RegulatoryRates } from '../types/regulatoryRates';
import { ratesDefault2026 } from '../constants/regulatoryRatesDefault';

interface RatesState {
  current: RegulatoryRates;
  lastFetchedAt: Date | null;
  isLoading: boolean;

  setCurrent: (rates: RegulatoryRates) => void;
  setLoading: (isLoading: boolean) => void;
}

export const useRatesStore = create<RatesState>()(
  devtools(
    (set) => ({
      current: ratesDefault2026,
      lastFetchedAt: null,
      isLoading: false,

      setCurrent: (rates) =>
        set({
          current: rates,
          lastFetchedAt: new Date(),
          isLoading: false,
        }),

      setLoading: (isLoading) => set({ isLoading }),
    }),
    { name: 'ratesStore' },
  ),
);
